const domainRoot = process.env.PUBLIC_URL;

console.log("domainRoot", domainRoot);

export const apiRoot = `${domainRoot || "https://tencoltask.azurewebsites.net/hca-connect"}/api`;
export const resourcesRoot = domainRoot;

// I'm not sure how the original code worked as the partImagesRoot seemed too generic to be a public URL.
//export const partImagesRoot = 'https://draegerstore.blob.core.windows.net/monitoring-images';
export const partImagesRoot = "https://draegerstore.z22.web.core.windows.net";
